import {
    getAllUsers,
    getBlockedEmails,
    getPreservedTrackerLogs,
    getTariffs,
    getTrackerSegmentEmulatingLogs,
} from "sources/admin";
import { getRegistryLogs } from "sources/admin/registryPoints";
import { getInfoList as accessPermits, index as adminAccessPermits } from "sources/books/accessPermits";
import { index as counterpartiesInsolvencyRegistryList } from "sources/books/admin/counterpartiesInsolvencyRegistry";
import { index as adminDrivers } from "sources/books/admin/drivers";
import { index as feedbackTags } from "sources/books/admin/feedbackTags";
import { mobileAppRatings } from "sources/books/admin/mobileApp";
import { index as adminOrganizations } from "sources/books/admin/organizations";
import { index as paymentPoints } from "sources/books/admin/paymentPoints";
import { index as integrationClients } from "sources/admin/integrationClients";
import { index as regionDryingPeriods } from "sources/books/admin/regionDryingPeriods";
import { index as unstableZones } from "sources/books/admin/unstableZones";
import { closeBidsList as bids } from "sources/books/bids";
import { index as calculationQueues } from "sources/books/calculationQueues";
import { index as cargoOwners } from "sources/books/cargoOwners";
import { index as chats } from "sources/books/chats";
import { index as classificationTypes } from "sources/books/classificationTypes";
import { index as counterpartyContracts } from "sources/books/counterpartyContracts";
import { index as counterpartyGroups } from "sources/books/counterpartyGroups";
import { index as counterpartypoints } from "sources/books/counterpartyPoints";
import { index as couplings } from "sources/books/couplings";
import { index as customPoints } from "sources/books/customPointTypes";
import { index as dictionaries, getCatalogItems as organizationcatalogitems } from "sources/books/dictionaries";
import { index as distributionBidSources } from "sources/books/distributionBidSources";
import {
    index as distributionBids,
    getMatchingForCar as suitableDistributionBids,
} from "sources/books/distributionBids";
import { index as documentTemplates } from "sources/books/documentTemplates";
import { index as documentTracking } from "sources/books/documentTracking";
import { index as drivers } from "sources/books/drivers";
import { index as emergencyAreaPoints } from "sources/books/emergencyArea";
import { index as expenses } from "sources/books/expenses";
import { index as documentsList, getListForBid, getListForDistributionBid } from "sources/books/finance";
import { index as fixRouteBids, getListForOrganization } from "sources/books/fixRouteBids";
import { index as hiredCars } from "sources/books/hiredCars";
import { index as hiredDrivers } from "sources/books/hiredDrivers";
import { index as hiredTrailers } from "sources/books/hiredTrailers";
import { index as itemChangePoints } from "sources/books/itemChangePoints";
import { index as legalPersons } from "sources/books/legalPersons";
import { index as logists } from "sources/books/logists";
import { index as news } from "sources/books/news";
import { index as notificationQueues } from "sources/books/notificationQueues";
import { index as organizationRecommendations } from "sources/books/organizationRecommendations";
import { index as adminPlatformNews, getListForView as userPlatformNews } from "sources/books/platformNews";
import { index as platonPoints } from "sources/books/platonPoints";
import { index as popups } from "sources/books/popups";
import { index as popupTemplates } from "sources/books/popupTemplates";
import { index as getPostamatPoints } from "sources/books/postamatPoints";
import { index as regionGroups } from "sources/books/regionGroups";
import { index as registries } from "sources/books/registries";
import { index as routeControlPoints } from "sources/books/routeControlPoints";
import { index as routeTemplates } from "sources/books/routeTemplates";
import { index as scenarios } from "sources/books/scenarios";
import { getKanban, index as logistTasks } from "sources/books/tasks";
import { index as trackerHistory } from "sources/books/trackerHistory";
import { getTrackersInfo, index as trackers } from "sources/books/trackers";
import { index as trailers } from "sources/books/trailers";
import { index as transportColumns } from "sources/books/transportColumns";
import { index as tripScenarios } from "sources/books/tripScenarios";
import { index as tripSheets } from "sources/books/tripSheets";
import { getCarLogistPeriods, index as trucks } from "sources/books/trucks";
import { index as universalTransferDocuments } from "sources/books/universalTransferDocuments";
import { index as userLogs } from "sources/books/userLogs";
import { getCarsList, getGroupsCarList, getUsersList, index as usersGroups } from "sources/books/usersGroups";
import { index as carChats } from "sources/carChats";
import { index as organizationCatalogs, systemCatalogs } from "sources/catalogs";
import { index as adminParcelStatuses } from "sources/parcel";
import { index as shippingOrders } from "sources/shippingOrders";
import { index as waybills } from "sources/waybills";

const actionsList = {
    sharedbids: { list: bids },
    bids: { list: bids },
    drivers: { list: drivers },
    "hired-cars": { list: hiredCars },
    "hired-trailers": { list: hiredTrailers },
    "hired-drivers": { list: hiredDrivers },
    trailers: { list: trailers },
    trucks: { list: trucks },
    chats: { list: chats },
    notifications: { list: chats },
    "car-chats": { list: carChats },
    dictionaries: { list: dictionaries },
    trackers: { list: trackers },
    cargoowners: { list: cargoOwners },
    calculationqueues: { list: calculationQueues },
    allusers: { list: getAllUsers },
    userlogs: { list: userLogs },
    admindrivers: { list: adminDrivers },
    adminorganizations: { list: adminOrganizations },
    logists: { list: logists },
    routetemplates: { list: routeTemplates },
    distributionbids: { list: distributionBids },
    custompoints: { list: customPoints },
    "item-change-points": { list: itemChangePoints },
    "region-groups": { list: regionGroups },
    organizationcatalogs: { list: organizationCatalogs },
    organizationcatalogitems: { list: organizationcatalogitems },
    counterpartypoints: { list: counterpartypoints },
    "postamat-points": { list: getPostamatPoints },
    "select-item-change-points": { list: itemChangePoints },
    scenarios: { list: scenarios },
    "trip-scenarios": { list: tripScenarios },
    trackersinfo: { list: getTrackersInfo },
    trackerhistory: { list: trackerHistory },
    transportcolumns: { list: transportColumns },
    couplings: { list: couplings },
    news: { list: news },
    "logist-history": { list: getCarLogistPeriods },
    expenses: { list: expenses },
    "suitable-distribution-bids": { list: suitableDistributionBids },
    "notification-queues": { list: notificationQueues },
    "blocked-emails": { list: getBlockedEmails },
    "admin-tariffs": { list: getTariffs },
    "distribution-bid-sources": { list: distributionBidSources },
    "counterparty-groups": { list: counterpartyGroups },
    "counterparty-contracts": { list: counterpartyContracts },
    "system-catalogs": { list: systemCatalogs },
    "admin-fix-route-bids": { list: fixRouteBids },
    "organization-fix-route-bids": { list: getListForOrganization },
    "neural-network-logs": { list: getRegistryLogs },
    "organization-recommendations": { list: organizationRecommendations },
    "mobile-app-ratings": { list: mobileAppRatings },
    tasks: { list: logistTasks },
    "kanban-tasks": { list: getKanban },
    "legal-persons": { list: legalPersons },
    popups: { list: popups },
    "popup-templates": { list: popupTemplates },
    "platon-points": { list: platonPoints },
    "emergency-area-points": { list: emergencyAreaPoints },
    "route-control-points": { list: routeControlPoints },
    "admin-platform-news": { list: adminPlatformNews },
    "user-platform-news": { list: userPlatformNews },
    "payment-points": { list: paymentPoints },
    "emulated-segments-logs": { list: getTrackerSegmentEmulatingLogs },
    "preserved-tracker-logs": { list: getPreservedTrackerLogs },
    "feedback-tags": { list: feedbackTags },
    "users-groups": { list: usersGroups },
    "users-group-cars": { list: getCarsList },
    "users-groups-cars": { list: getGroupsCarList },
    "users-group-users": { list: getUsersList },
    "unstable-zones": { list: unstableZones },
    "region-drying-periods": { list: regionDryingPeriods },
    "admin-insolvency-registry": { list: counterpartiesInsolvencyRegistryList },
    "admin-access-permits": { list: adminAccessPermits },
    "integration-clients": { list: integrationClients },
    "access-permits": { list: accessPermits },
    "admin-parcel-statuses": { list: adminParcelStatuses },
    "document-templates": { list: documentTemplates },
    "document-tracking": { list: documentTracking },
    "classification-types": { list: classificationTypes },
    "finances-invoice": { list: documentsList },
    "finances-contract": { list: documentsList },
    "finances-acceptance-certificate": { list: documentsList },
    "finances-acceptance-certificate-invoice": { list: documentsList },
    "finances-universal-transfer-documents": { list: universalTransferDocuments },
    "finances-registries": { list: registries },
    "finances-bid-documents": { list: getListForBid },
    "finances-distribution-bid-documents": { list: getListForDistributionBid },
    "trip-sheets": { list: tripSheets },
    "shipping-orders": { list: shippingOrders },
    waybills: { list: waybills },
};

export default actionsList;
